import { useState } from "react";
import { XFreighterRamp } from "./XFreighterRamp";
import { XTypography } from "./XTypography";

export const XFreighterRampTester = () => {
  const [levels, setLevels] = useState([
    {
      level: 0,
      playerId: "a",
    },
    {
      level: 1,
      playerId: "b",
    },
    {
      level: 2,
      playerId: "c",
    },
    {
      level: 3,
      playerId: "d",
    },
  ]);

  const updateLevel = (
    levelObj: { playerId: string; level: number },
    value: number
  ) => {
    levelObj.level = value;
    setLevels([...levels]);
  };

  return (
    <div>
      <XFreighterRamp levels={levels} />
      <div style={{ display: "flex" }}>
        {levels.map((levelObj) => {
          const { playerId, level } = levelObj;
          return (
            <div key={playerId}>
              <input
                type="button"
                onClick={() => updateLevel(levelObj, level + 1)}
                value="+"
              />
              <XTypography>{level}</XTypography>
              <input
                type="button"
                onClick={() => updateLevel(levelObj, level - 1)}
                value="-"
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
